import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { AppUserStoreInfo } from '@/interfaces/service/api.interface';

interface FavoriteStoreState {
  // === 상태 ===
  // 관심병원 정보
  appUserStoreInfo: AppUserStoreInfo | null;

  // === 상태 업데이트 액션 ===
  // 관심병원 정보 업데이트
  setAppUserStoreInfo: (info: AppUserStoreInfo | null) => void;
  // 스토어 초기화
  clearFavoriteStore: () => void;

  // API 응답에서 관심병원 정보 업데이트
  updateFavoriteStore: (apiResponseData: any) => void;

  // === 관심병원 접근자 ===
  // 관심병원 ID 접근
  getUserStoreId: () => number | undefined;

  // 관심병원 이름 접근
  getUserStoreName: () => string | undefined;

  // 관심병원 상세 접근
  getUserStoreDetail: () => string | undefined;
}

export const useFavoriteStore = create<FavoriteStoreState>()(
  devtools(
    persist(
      (set, get) => ({
        // === 초기 상태 ===
        appUserStoreInfo: null,

        // === 상태 업데이트 함수 ===
        setAppUserStoreInfo: (appUserStoreInfo) => set({ appUserStoreInfo }),

        updateFavoriteStore: (apiResponseData) => {
          const { appUserStoreInfo } = apiResponseData || {};
          set({
            appUserStoreInfo: appUserStoreInfo || null
          });
        },

        clearFavoriteStore: () =>
          set({
            appUserStoreInfo: null
          }),

        // === 관심병원 접근자 ===
        getUserStoreId: () => {
          return get().appUserStoreInfo?.storeId;
        },

        getUserStoreName: () => {
          return get().appUserStoreInfo?.storeName;
        },

        getUserStoreDetail: () => {
          return get().appUserStoreInfo?.storeDetail;
        }
      }),
      {
        name: 'favorite-store-storage',
        storage: createJSONStorage(() => sessionStorage)
      }
    ),
    {
      name: 'favorite-store'
    }
  )
);
